import React, { useContext, useEffect, useState } from "react";
import { MissionContext } from "../contexts/MissionTasksContext";
import CustomCard from "components/common/CustomCard";
import CardBody from "components/common/CardBody";
import Row from "components/common/Row";
import Column from "components/common/Column";
import { useLazyGetFormDataVariablesQuery } from "modules/pvs_activities/redux/service/formData";
import { processVariables } from "modules/pvs_activities/helper.general";
import Loader from "components/spinner/Loader";
import { BsInfoCircleFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetExpertsByMissionIdQuery } from "modules/pvs_activities/redux/service/missions";
import { EXPERTS_POSITIONS } from "modules/pvs_activities/constants";
import { ROLES_LIST } from "constants";
import { USER_ROLES } from "constants";

const MissionInfo = () => {

  const { id } = useParams();
  const peerExperts = useGetExpertsByMissionIdQuery({ missionID: id });
  const authData = useSelector(s => s.auth.data);
  const missionContext = useContext(MissionContext);
  const [triggerVariables, variablesRes] = useLazyGetFormDataVariablesQuery();
  const [showMessage, setShowMessage] = useState(false);
  const isPeerReviewer = () => {
    const filteredExpert = peerExperts?.data?.find(expert => (expert?.expert.user_id === authData?.id && expert.position_id === EXPERTS_POSITIONS.peer_reviewer));
    if (filteredExpert) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (missionContext.missionData?.id) {
      triggerVariables(missionContext.missionData?.id, true);
    }
  }, [missionContext.missionData?.id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <><CustomCard className='shadow-sm my-3 bg-secondary'>
      <CardBody>
        <Row className='border-bottom border-4 py-2'>
          <Column col={6}>
            <div className="d-flex fs-4">
              <p className="fw-bold mb-0">Country:</p>
              {
                missionContext.isLoading
                  ? <Loader message={"Loading..."} className="text-muted ms-3" />
                  : <p className="ms-3 mb-0">{missionContext.missionData?.Country?.country_name}</p>
              }
            </div>
          </Column>
          <Column col={6}>
            <div className="d-flex fs-4">
              <p className="fw-bold mb-0">Sector:</p>
              {
                missionContext.isLoading
                  ? <Loader message={"Loading..."} className="text-muted ms-3" />
                  : <p className="ms-3 mb-0">{missionContext.missionData?.mission_sector}</p>
              }
            </div>
          </Column>
        </Row>
        <Row className='border-bottom border-4 py-2'>
          <Column col={6}>
            <div className="d-flex fs-4">
              <p className="fw-bold mb-0">Mission Type:</p>
              {
                missionContext.isLoading
                  ? <Loader message={"Loading..."} className="text-muted ms-3" />
                  : <p className="ms-3 mb-0">{missionContext.missionData?.mission_type_name}</p>
              }
            </div>
          </Column>
          <Column col={6}>
            {isPeerReviewer() && (
              <div className="d-flex fs-4">
                <p className="fw-bold mb-0">Status:</p>
                <p className="ms-3 mb-0">In Progress</p>
              </div>
            )}
            {!isPeerReviewer() &&
              <div className="d-flex fs-4">
                <p className="fw-bold mb-0">Mission Manager:</p>
                {
                  missionContext.isLoading
                    ? <Loader message={"Loading..."} className="text-muted ms-3" />
                    : <p className="ms-3 mb-0">{
                      missionContext.missionData?.relationMissionManager ? missionContext.missionData?.relationMissionManager?.name : "Required Action"
                    }</p>
                }
              </div>
            }
          </Column>
        </Row>
        {!isPeerReviewer() && (
          <Row className='border-bottom border-4 py-2'>
            <Column col={6}>
              <div className="d-flex fs-4">
                <p className="fw-bold mb-0">Status:</p>
                <p className="ms-3 mb-0">{missionContext?.isMissionAborted ? "Aborted": "In Progress" }</p> 
              </div>
            </Column>
            <Column col={6}>
              <div className="d-flex fs-4">
                <p className="fw-bold mb-0">Expert Team Leader:</p>
                {
                  missionContext.isLoading
                    ? <Loader message={"Loading..."} className="text-muted ms-3" />
                    : <>
                      {
                        variablesRes?.status === "fulfilled" && variablesRes.data.expert_team_leader &&
                        <div className="ms-3 mb-0" dangerouslySetInnerHTML={{ __html: processVariables(variablesRes, "expert_team_leader") }} />
                      }
                    </>
                }
              </div>
            </Column>

          </Row>
        )}


      </CardBody>
    </CustomCard>

      {
        missionContext.isLoading ? (
          <>
            <Loader message={"Loading..."} />
          </>
        ) :
          <>
            {
              !(missionContext.missionManager) && !missionContext?.isMissionAborted && showMessage && (
                <>
                  <CustomCard className='shadow-sm py-1 bg-light'>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <BsInfoCircleFill className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer" size={24} />
                        <div className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center" role="alert">
                          <div className="fs-4 text-justify me-0">
                            {(USER_ROLES.delegate.includes(parseInt(authData.role_id))) && ("Your mission request is currently under review and will be processed soon.")}
                            {(USER_ROLES.business_admin.includes(parseInt(authData.role_id))) && ("Please assign a Mission Manager using the ‘Mission Configuration’ button to proceed further.")}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </>
              )}
          </>

      }

    </>
  );
};

export default MissionInfo;
